import React, { useState, useEffect, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AccountsMenu from "./AccountsMenu";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function BudgetHeadWise() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [DefaultFYear] = useState(
    () => localStorage.getItem("DefaultFYear") || ""
  );

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [ClosingDebitTotal, setClosingDebitTotal] = useState("");
  const [ClosingCreditTotal, setClosingCreditTotal] = useState("");
  const [BalanceTotal, setBalanceTotal] = useState("");
  const [BudgetTotal, setBudgetTotal] = useState("");

  const [AccountLevel, setAccountLevel] = useState("0");
  const [EndDate, setEndDate] = useState(() =>
    moment().format(config.date_format_input)
  );
  const [zeroAccounts, setZeroAccounts] = useState(true);
  const [Account_Code, setAccount_Code] = useState("");
  const [Account_Description, setAccount_Description] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [appliedName, setAppliedName] = useState("");

  const [pageNo] = useState(1);
  const [pageSize] = useState(10000);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchBudget = useCallback(
    () => {
      const year = parseInt(DefaultFYear, 10);
      if (!year) {
        setLedger([]);
        toast.error("Financial year is not set. Use Accounts → Change Year.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      if (!EndDate) {
        setLedger([]);
        return;
      }

      setLoading(true);
      axios({
        method: "post",
        url: config.base_url + "Accounts/GetBudgetHeadWise",
        headers: { "Content-Type": "application/json" },
        data: {
          AccessKey,
          UserID,
          MemberType,
          pageNo,
          pageSize,
          FYear: year,
          EndDate: EndDate,
          AccountLevel: parseInt(AccountLevel, 10) || 0,
          ShowZeroAccounts: zeroAccounts,
          AccountCode: appliedCode,
          AccountName: appliedName,
          ShowThirdOnly: false,
        },
      })
        .then((response) => {
          if (response.data?.status_code !== 0) {
            setLedger(
              Array.isArray(response.data?.ListofRecords)
                ? response.data.ListofRecords
                : []
            );
            setTotalRecords(response.data?.totalRecords ?? 0);
            setClosingDebitTotal(response.data?.ClosingDebitTotal ?? "");
            setClosingCreditTotal(response.data?.ClosingCreditTotal ?? "");
            setBudgetTotal(response.data?.BudgetTotal ?? "");
            setBalanceTotal(response.data?.BalanceTotal ?? "");
          } else {
            setLedger([]);
            setTotalRecords(0);
            setClosingDebitTotal(response.data?.ClosingDebitTotal ?? "");
            setClosingCreditTotal(response.data?.ClosingCreditTotal ?? "");
            setBudgetTotal(response.data?.BudgetTotal ?? "");
            setBalanceTotal(response.data?.BalanceTotal ?? "");
          }
        })
        .catch(() => {
          setLedger([]);
          toast.error("Network Error..", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .finally(() => setLoading(false));
    },
    [
      AccessKey,
      UserID,
      MemberType,
      DefaultFYear,
      EndDate,
      AccountLevel,
      zeroAccounts,
      appliedCode,
      appliedName,
      pageNo,
      pageSize,
    ]
  );

  useEffect(() => {
    document.title = "Budget Head Wise";
    fetchBudget();
  }, [fetchBudget]);

  const handleSearch = () => {
    setAppliedCode((Account_Code || "").trim());
    setAppliedName((Account_Description || "").trim());
    fetchBudget();
  };

  const printParams = new URLSearchParams({
    fyear: DefaultFYear || "",
    endDate: EndDate || "",
    accountLevel: AccountLevel || "0",
    showZeroAccounts: zeroAccounts ? "1" : "0",
    accountCode: Account_Code || "",
    accountName: Account_Description || "",
  });

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.Selected_Account.Account_Code}</td>
          <td>{item.Selected_Account.Account_Description}</td>
          <td className="text-end">{item.ClosingDebit}</td>
          <td className="text-end">{item.ClosingCredit}</td>
          <td className="text-end">{item.Budget_Allocation}</td>
          <td className="text-end">{item.Balance}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="7">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <AccountsMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Budget Head Wise
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Budget Head Wise</div>
                <p className="text-muted small mb-0">
                  Accounts with budget allocation only. Balance = Budget − Debit
                  + Credit (utilized). Year: {DefaultFYear || "—"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-end gy-3">
                  <div className="col-md-2">
                    <label>Select Level</label>
                    <select
                      className="form-select"
                      value={AccountLevel}
                      onChange={(e) => setAccountLevel(e.target.value)}
                    >
                      <option value="0">All Levels</option>
                      <option value="1">1st Level</option>
                      <option value="2">2nd Level</option>
                      <option value="3">3rd Level</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>As On</label>
                    <input
                      type="date"
                      className="form-control"
                      value={EndDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      max={moment().format(config.date_format_input)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Account Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={Account_Code}
                      onChange={(e) => setAccount_Code(e.target.value)}
                      placeholder="e.g. 701"
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Account Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={Account_Description}
                      onChange={(e) => setAccount_Description(e.target.value)}
                      placeholder="Search name"
                    />
                  </div>
                  <div className="col-md-2">
                    <div className="form-check mt-md-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={zeroAccounts}
                        onChange={(e) => setZeroAccounts(e.target.checked)}
                        id="budgetZeroAccounts"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="budgetZeroAccounts"
                      >
                        Show zero utilization
                      </label>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <button
                      type="button"
                      className="button button-primary w-100"
                      onClick={handleSearch}
                      disabled={loading}
                    >
                      Search
                    </button>
                  </div>
                  <div className="col-md-1">
                    <Link
                      to={`/Accounts/PrintBudgetHeadWise?${printParams.toString()}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-100 button button-primary"
                      onClick={(e) => {
                        if (!EndDate) {
                          e.preventDefault();
                          window.alert("Please select As On date before printing.");
                        }
                      }}
                    >
                      Print
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-body responsive-table">
                <table className="table table-theme table-hover">
                  <tbody>
                    <tr>
                      <th>Sr.</th>
                      <th>Account Code</th>
                      <th>Account Name</th>
                      <th colSpan="2" className="text-center">
                        Utilized Budget
                      </th>
                      <th>Budget Allocation</th>
                      <th>Balance</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th className="text-end">Debit</th>
                      <th className="text-end">Credit</th>
                      <th></th>
                      <th></th>
                    </tr>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="7">
                          <Spinner animation="border" role="status" />
                        </td>
                      </tr>
                    ) : (
                      renderLedger()
                    )}
                    <tr>
                      <td></td>
                      <td></td>
                      <td className="text-end fw-bold">Total</td>
                      <td className="text-end fw-bold">{ClosingDebitTotal}</td>
                      <td className="text-end fw-bold">{ClosingCreditTotal}</td>
                      <td className="text-end fw-bold">{BudgetTotal}</td>
                      <td className="text-end fw-bold">{BalanceTotal}</td>
                    </tr>
                  </tbody>
                </table>
                {!loading && totalRecords > 0 && (
                  <p className="text-muted small mb-0">
                    Showing {listOfLedger.length} of {totalRecords} account(s)
                    with budget allocation
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BudgetHeadWise;
